// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__utH5p","swipe":"styles_swipe__Mbgzu"};